import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Emit } from 'vue-property-decorator';

@Component({
})
export default class ClientSortPanel extends Vue {
    @Prop({default: 'name_asc'}) sortBy!: 'name_asc' | 'name_desc'

    sortList = [
        {
            viewName: 'Наименованию (А - Я)',
            name: 'name_asc',
        },
        {
            viewName: 'Наименованию (Я - А)',
            name: 'name_desc',
        },
    ]

    @Prop({ default: 'grid' }) viewListMode!: 'grid' | 'list'
    @Emit('sort') onSortByChanged(sortType: 'name_asc' | 'name_desc') {
        this.$forceUpdate()
        return sortType
    }
    @Emit('showFilterDrawer') showFilterDrawer() {
        return true
    }
    @Emit('update:viewListMode') viewListModeChange(e: 'grid' | 'list') {
        return e
    }
    get currentSort() {
        const currSortObj = this.sortList.find((item) => item.name === this.sortBy)
        return currSortObj!.viewName
    }
}